import React, { useState, useEffect, useRef } from 'react';
import Layout from '../components/layout/Layout/Layout';
import consultasService from '../services/consultasService';
// import ReCaptcha from '../components/common/ReCaptcha/ReCaptcha';
import './Formulario.scss';

const MOTIVOS_CONSULTA = [
  { id: 'telepase', label: 'TelePase', campos: ['ruta', 'dominio', 'numeroTag'] },
  { id: 'exencion', label: 'Exención discapacidad', campos: ['ruta'] },
  { id: 'licitaciones', label: 'Consulta licitaciones', campos: ['ruta'] },
  { id: 'facturacion', label: 'Facturación', campos: ['ruta'] },
  { id: 'accidente', label: 'Accidente/siniestro', campos: ['ruta', 'km'] },
  { id: 'mantenimiento', label: 'Mantenimiento banquina/calzadas', campos: ['ruta'] },
  { id: 'veteranos', label: 'Veteranos Malvinas', campos: ['ruta'] }
];

const RUTAS = [
  { id: 'au1', label: 'AU1 - Acceso Norte' },
  { id: 'au6', label: 'AU6 - Acceso Oeste' },
  { id: 'au7', label: 'AU7 - Acceso Sur' },
  { id: 'au25', label: 'AU25 - Acceso Riccheri' },
  { id: 'rn8', label: 'RN8 - Pilar - Pergamino' },
  { id: 'rn9', label: 'RN9 - Zárate - Lima' }
];

const FormularioConsultas = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    apellidoNombre: '', dni: '', codigoArea: '', telefono: '', email: '',
    motivoConsulta: '', ruta: '', dominio: '', numeroTag: '', km: '', mensaje: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rutasDisponibles, setRutasDisponibles] = useState(RUTAS);
  const [motivosDisponibles, setMotivosDisponibles] = useState([]);
  const [captchaToken, setCaptchaToken] = useState('');
  const recaptchaRef = useRef(null);

  useEffect(() => {
    const cargarDatosIniciales = async () => {
      try {
        const [rutasData, motivosData] = await Promise.all([
          consultasService.getRutas(),
          consultasService.getMotivosConsulta()
        ]);
        
        setRutasDisponibles(Array.isArray(rutasData) ? rutasData : RUTAS);
        setMotivosDisponibles(Array.isArray(motivosData) ? motivosData : MOTIVOS_CONSULTA);
      } catch (error) {
        console.error('Error al cargar datos iniciales:', error);
        setRutasDisponibles(RUTAS);
        setMotivosDisponibles(MOTIVOS_CONSULTA);
      }
    };

    cargarDatosIniciales();
  }, []);

  const validateStep = (step) => {
    const newErrors = {};
    
    if (step === 1) {
      if (!formData.apellidoNombre.trim()) newErrors.apellidoNombre = 'Campo requerido';
      if (!formData.dni.trim()) newErrors.dni = 'Campo requerido';
      if (!formData.codigoArea.trim()) newErrors.codigoArea = 'Campo requerido';
      if (!formData.telefono.trim()) newErrors.telefono = 'Campo requerido';
      if (!formData.email.trim()) newErrors.email = 'Campo requerido';
      else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email inválido';
    }
    
    if (step === 2) {
      if (!formData.motivoConsulta) newErrors.motivoConsulta = 'Debe seleccionar un motivo';
      
      const motivoSeleccionado = (Array.isArray(motivosDisponibles) ? motivosDisponibles : MOTIVOS_CONSULTA).find(m => m.id === formData.motivoConsulta);
      if (motivoSeleccionado) {
        motivoSeleccionado.campos.forEach(campo => {
          if (!formData[campo]?.trim()) {
            newErrors[campo] = 'Campo requerido';
          }
        });
      }
    }
    
    if (step === 3) {
      if (!formData.mensaje.trim()) newErrors.mensaje = 'Debe incluir un mensaje';
      // if (!captchaToken) newErrors.captcha = 'Debe completar la verificación reCAPTCHA';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const nextStep = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
  };

  // const handleCaptchaVerify = (token) => {
  //   setCaptchaToken(token);
  //   if (errors.captcha) {
  //     setErrors(prev => ({ ...prev, captcha: '' }));
  //   }
  // };

  // const handleCaptchaExpire = () => {
  //   setCaptchaToken('');
  //   setErrors(prev => ({ ...prev, captcha: 'La verificación reCAPTCHA ha expirado. Intente nuevamente.' }));
  // };

  // const handleCaptchaError = () => {
  //   setCaptchaToken('');
  //   setErrors(prev => ({ ...prev, captcha: 'Error al cargar reCAPTCHA. Verifique su conexión.' }));
  // };

  const handleSubmit = async () => {
    if (!validateStep(3)) return;
    
    setIsSubmitting(true);
    try {
      const datosEnvio = {
        ...formData,
        telefono_completo: `${formData.codigoArea}${formData.telefono}`,
        fecha_envio: new Date().toISOString(),
        captcha_token: captchaToken,
        ip_cliente: 'N/A'
      };

      const resultado = await consultasService.enviarConsulta(datosEnvio);
      
      if (resultado.success) {
        alert('¡Consulta enviada exitosamente! Recibirá una respuesta a la brevedad.');
        
        // Reset form
        setFormData({
          apellidoNombre: '', dni: '', codigoArea: '', telefono: '', email: '',
          motivoConsulta: '', ruta: '', dominio: '', numeroTag: '', km: '', mensaje: ''
        });
        setCaptchaToken('');
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        setCurrentStep(1);
      } else {
        alert(`Error al enviar la consulta: ${resultado.message}`);
      }
    } catch (error) {
      console.error('Error inesperado:', error);
      alert('Error inesperado al enviar la consulta. Intente nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout>
      <div className="formulario-consultas">
        <div className="container">
          <div className="formulario-header">
            <h1>Formulario de Consultas</h1>
            <p>Complete los siguientes pasos para enviar su consulta</p>
          </div>

          <div className="stepper">
            <div className={`step ${currentStep >= 1 ? 'active' : ''} ${currentStep > 1 ? 'completed' : ''}`}>
              <div className="step-number">1</div>
              <div className="step-label">Datos Personales</div>
            </div>
            <div className={`step ${currentStep >= 2 ? 'active' : ''} ${currentStep > 2 ? 'completed' : ''}`}>
              <div className="step-number">2</div>
              <div className="step-label">Detalles</div>
            </div>
            <div className={`step ${currentStep >= 3 ? 'active' : ''} ${currentStep > 3 ? 'completed' : ''}`}>
              <div className="step-number">3</div>
              <div className="step-label">Mensaje</div>
            </div>
          </div>

          <div className="form-container">
            {currentStep === 1 && (
              <div className="form-step">
                <h3 className="step-title">Datos Personales</h3>
                
                <div className="form-group">
                  <label htmlFor="apellidoNombre">Apellido y Nombre *</label>
                  <input
                    type="text"
                    id="apellidoNombre"
                    value={formData.apellidoNombre}
                    onChange={(e) => handleInputChange('apellidoNombre', e.target.value)}
                    className={errors.apellidoNombre ? 'error' : ''}
                    placeholder="Ingrese su apellido y nombre completo"
                  />
                  {errors.apellidoNombre && <span className="error-message">{errors.apellidoNombre}</span>}
                </div>

                <div className="form-group">
                  <label htmlFor="dni">DNI *</label>
                  <input
                    type="text"
                    id="dni"
                    value={formData.dni}
                    onChange={(e) => handleInputChange('dni', e.target.value.replace(/\D/g, ''))}
                    className={errors.dni ? 'error' : ''}
                    placeholder="12345678"
                    maxLength="8"
                  />
                  {errors.dni && <span className="error-message">{errors.dni}</span>}
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="codigoArea">Código de área *</label>
                    <input
                      type="text"
                      id="codigoArea"
                      value={formData.codigoArea}
                      onChange={(e) => handleInputChange('codigoArea', e.target.value.replace(/\D/g, ''))}
                      className={errors.codigoArea ? 'error' : ''}
                      placeholder="011"
                      maxLength="4"
                    />
                    {errors.codigoArea && <span className="error-message">{errors.codigoArea}</span>}
                  </div>

                  <div className="form-group">
                    <label htmlFor="telefono">Teléfono *</label>
                    <input
                      type="text"
                      id="telefono"
                      value={formData.telefono}
                      onChange={(e) => handleInputChange('telefono', e.target.value.replace(/\D/g, ''))}
                      className={errors.telefono ? 'error' : ''}
                      placeholder="12345678"
                      maxLength="10"
                    />
                    {errors.telefono && <span className="error-message">{errors.telefono}</span>}
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="email">Correo electrónico *</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    className={errors.email ? 'error' : ''}
                    placeholder="ejemplo@correo.com"
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
              </div>
            )}

            {currentStep === 2 && (
              <div className="form-step">
                <h3 className="step-title">Detalles de la Consulta</h3>
                
                <div className="form-group">
                  <label htmlFor="motivoConsulta">Motivo de consulta *</label>
                  <select
                    id="motivoConsulta"
                    value={formData.motivoConsulta}
                    onChange={(e) => handleInputChange('motivoConsulta', e.target.value)}
                    className={errors.motivoConsulta ? 'error' : ''}
                  >
                    <option value="">Seleccione un motivo</option>
                    {(Array.isArray(motivosDisponibles) ? motivosDisponibles : MOTIVOS_CONSULTA).map(motivo => (
                      <option key={motivo.id} value={motivo.id}>{motivo.label}</option>
                    ))}
                  </select>
                  {errors.motivoConsulta && <span className="error-message">{errors.motivoConsulta}</span>}
                </div>

                {formData.motivoConsulta && (() => {
                  const motivoSeleccionado = (Array.isArray(motivosDisponibles) ? motivosDisponibles : MOTIVOS_CONSULTA).find(m => m.id === formData.motivoConsulta);
                  return motivoSeleccionado && (
                    <div className="campos-dinamicos">
                      {motivoSeleccionado.campos.includes('ruta') && (
                        <div className="form-group">
                          <label htmlFor="ruta">Ruta *</label>
                          <select
                            id="ruta"
                            value={formData.ruta}
                            onChange={(e) => handleInputChange('ruta', e.target.value)}
                            className={errors.ruta ? 'error' : ''}
                          >
                            <option value="">Seleccione una ruta</option>
                            {(Array.isArray(rutasDisponibles) ? rutasDisponibles : RUTAS).map(ruta => (
                              <option key={ruta.id} value={ruta.id}>{ruta.label}</option>
                            ))}
                          </select>
                          {errors.ruta && <span className="error-message">{errors.ruta}</span>}
                        </div>
                      )}

                      {motivoSeleccionado.campos.includes('dominio') && (
                        <div className="form-group">
                          <label htmlFor="dominio">Dominio *</label>
                          <input
                            type="text"
                            id="dominio"
                            value={formData.dominio}
                            onChange={(e) => handleInputChange('dominio', e.target.value.toUpperCase())}
                            className={errors.dominio ? 'error' : ''}
                            placeholder="ABC123"
                            maxLength="7"
                          />
                          {errors.dominio && <span className="error-message">{errors.dominio}</span>}
                        </div>
                      )}

                      {motivoSeleccionado.campos.includes('numeroTag') && (
                        <div className="form-group">
                          <label htmlFor="numeroTag">Número de tag/dispositivo *</label>
                          <input
                            type="text"
                            id="numeroTag"
                            value={formData.numeroTag}
                            onChange={(e) => handleInputChange('numeroTag', e.target.value)}
                            className={errors.numeroTag ? 'error' : ''}
                            placeholder="Ingrese el número del tag"
                          />
                          {errors.numeroTag && <span className="error-message">{errors.numeroTag}</span>}
                        </div>
                      )}

                      {motivoSeleccionado.campos.includes('km') && (
                        <div className="form-group">
                          <label htmlFor="km">Kilómetro *</label>
                          <input
                            type="text"
                            id="km"
                            value={formData.km}
                            onChange={(e) => handleInputChange('km', e.target.value.replace(/\D/g, ''))}
                            className={errors.km ? 'error' : ''}
                            placeholder="Ej: 25"
                          />
                          {errors.km && <span className="error-message">{errors.km}</span>}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            )}

            {currentStep === 3 && (
              <div className="form-step">
                <h3 className="step-title">Mensaje y Envío</h3>
                
                <div className="form-group">
                  <label htmlFor="mensaje">Mensaje *</label>
                  <textarea
                    id="mensaje"
                    value={formData.mensaje}
                    onChange={(e) => handleInputChange('mensaje', e.target.value)}
                    className={errors.mensaje ? 'error' : ''}
                    placeholder="Describa su consulta en detalle..."
                    rows="6"
                  />
                  {errors.mensaje && <span className="error-message">{errors.mensaje}</span>}
                </div>

                <div className="resumen-consulta">
                  <h4>Resumen de su consulta:</h4>
                  <div className="resumen-item">
                    <strong>Nombre:</strong> {formData.apellidoNombre}
                  </div>
                  <div className="resumen-item">
                    <strong>Email:</strong> {formData.email}
                  </div>
                  <div className="resumen-item">
                    <strong>Motivo:</strong> {(Array.isArray(motivosDisponibles) ? motivosDisponibles : MOTIVOS_CONSULTA).find(m => m.id === formData.motivoConsulta)?.label}
                  </div>
                  {formData.ruta && (
                    <div className="resumen-item">
                      <strong>Ruta:</strong> {(Array.isArray(rutasDisponibles) ? rutasDisponibles : RUTAS).find(r => r.id === formData.ruta)?.label}
                    </div>
                  )}
                </div>

                <div className="captcha-section">
                  {/* <ReCaptcha
                    ref={recaptchaRef}
                    onVerify={handleCaptchaVerify}
                    onExpire={handleCaptchaExpire}
                    onError={handleCaptchaError}
                  /> */}
                  {errors.captcha && <span className="error-message">{errors.captcha}</span>}
                </div>
              </div>
            )}

            <div className="form-actions">
              {currentStep > 1 && (
                <button type="button" className="btn btn-secondary" onClick={prevStep}>
                  Anterior
                </button>
              )}
              
              {currentStep < 3 ? (
                <button type="button" className="btn btn-primary" onClick={nextStep}>
                  Siguiente
                </button>
              ) : (
                <button 
                  type="button" 
                  className="btn btn-success" 
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Consulta'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FormularioConsultas;

